<template>
  <div class="min-h-screen w-full bg-gradient-to-br from-gray-50 via-white to-marbel-yellow/5">
    <!-- Header de bienvenida -->
    <div class="bg-gradient-to-r from-marbel-aqua to-marbel-aqua-light px-6 py-8">
      <div class="max-w-6xl mx-auto">
        <div class="flex items-center justify-between">
          <div class="text-white">
            <h1 class="text-3xl font-bold mb-2">¡Bienvenido a MARBEL!</h1>
            <p class="text-white/90 text-lg">Sistema de Gestión • Transformando Espacios En Hogares</p>
          </div>
          <div class="hidden md:flex items-center space-x-4">
            <div class="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/30">
              <span class="text-white/90 text-sm">Más de</span>
              <span class="text-white font-bold text-xl ml-1">18 años</span>
              <span class="text-white/90 text-sm ml-1">de experiencia</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Contenido principal -->
    <div class="max-w-6xl mx-auto px-6 py-8">
      <!-- Métricas principales -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <!-- Tarjeta de cortinas -->
        <div class="bg-white rounded-xl shadow-lg p-6 border border-marbel-yellow/20 hover:shadow-xl transition-shadow">
          <div class="flex items-center justify-between mb-4">
            <div class="bg-marbel-yellow/20 p-3 rounded-lg">
              <span class="text-2xl">🪟</span>
            </div>
            <span class="text-marbel-aqua font-semibold">Cortinas</span>
          </div>
          <h3 class="text-2xl font-bold text-marbel-gray mb-2">250+</h3>
          <p class="text-marbel-gray/70 text-sm">Proyectos completados</p>
        </div>

        <!-- Tarjeta de persianas -->
        <div class="bg-white rounded-xl shadow-lg p-6 border border-marbel-aqua/20 hover:shadow-xl transition-shadow">
          <div class="flex items-center justify-between mb-4">
            <div class="bg-marbel-aqua/20 p-3 rounded-lg">
              <span class="text-2xl">🏠</span>
            </div>
            <span class="text-marbel-aqua font-semibold">Persianas</span>
          </div>
          <h3 class="text-2xl font-bold text-marbel-gray mb-2">180+</h3>
          <p class="text-marbel-gray/70 text-sm">Instalaciones realizadas</p>
        </div>

        <!-- Tarjeta de automatización -->
        <div class="bg-white rounded-xl shadow-lg p-6 border border-marbel-gray/20 hover:shadow-xl transition-shadow">
          <div class="flex items-center justify-between mb-4">
            <div class="bg-marbel-gray/20 p-3 rounded-lg">
              <span class="text-2xl">🤖</span>
            </div>
            <span class="text-marbel-aqua font-semibold">Automatización</span>
          </div>
          <h3 class="text-2xl font-bold text-marbel-gray mb-2">95+</h3>
          <p class="text-marbel-gray/70 text-sm">Sistemas inteligentes</p>
        </div>
      </div>

      <!-- Accesos rápidos -->
      <div class="bg-white rounded-xl shadow-lg p-6 mb-8">
        <h2 class="text-xl font-bold text-marbel-gray mb-6">Accesos Rápidos</h2>
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
          <button class="p-4 bg-gradient-to-br from-marbel-aqua/10 to-marbel-aqua/5 hover:from-marbel-aqua/20 hover:to-marbel-aqua/10 rounded-lg border border-marbel-aqua/20 transition-all hover:scale-105">
            <div class="text-center">
              <div class="text-marbel-aqua text-2xl mb-2">📋</div>
              <span class="text-sm font-medium text-marbel-gray">Cotizaciones</span>
            </div>
          </button>
          
          <button class="p-4 bg-gradient-to-br from-marbel-yellow/10 to-marbel-yellow/5 hover:from-marbel-yellow/20 hover:to-marbel-yellow/10 rounded-lg border border-marbel-yellow/20 transition-all hover:scale-105">
            <div class="text-center">
              <div class="text-marbel-yellow-dark text-2xl mb-2">📊</div>
              <span class="text-sm font-medium text-marbel-gray">Reportes</span>
            </div>
          </button>
          
          <button class="p-4 bg-gradient-to-br from-marbel-gray/10 to-marbel-gray/5 hover:from-marbel-gray/20 hover:to-marbel-gray/10 rounded-lg border border-marbel-gray/20 transition-all hover:scale-105">
            <div class="text-center">
              <div class="text-marbel-gray text-2xl mb-2">👥</div>
              <span class="text-sm font-medium text-marbel-gray">Clientes</span>
            </div>
          </button>
          
          <button class="p-4 bg-gradient-to-br from-green-100 to-green-50 hover:from-green-200 hover:to-green-100 rounded-lg border border-green-200 transition-all hover:scale-105">
            <div class="text-center">
              <div class="text-green-600 text-2xl mb-2">📦</div>
              <span class="text-sm font-medium text-marbel-gray">Inventario</span>
            </div>
          </button>
        </div>
      </div>

      <!-- Banner promocional MARBEL -->
      <div class="bg-gradient-to-r from-marbel-yellow via-marbel-yellow-light to-marbel-yellow rounded-xl p-6 text-center mb-8">
        <h3 class="text-2xl font-bold text-gray-900 mb-2">Transformando Espacios En Hogares</h3>
        <p class="text-gray-800 mb-4">
          Desde 2008, MARBEL ha sido líder en cortinas, persianas y automatización en Monterrey, N.L.
        </p>
        <div class="flex flex-wrap justify-center gap-4 text-sm">
          <span class="bg-white/20 px-3 py-1 rounded-full text-gray-800">✨ Calidad Premium</span>
          <span class="bg-white/20 px-3 py-1 rounded-full text-gray-800">🏆 18+ años experiencia</span>
          <span class="bg-white/20 px-3 py-1 rounded-full text-gray-800">💼 Servicio profesional</span>
        </div>
      </div>

      <!-- Información de contacto y estado -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Estado del sistema -->
        <div class="bg-white rounded-xl shadow-lg p-6">
          <h3 class="text-lg font-bold text-marbel-gray mb-4 flex items-center">
            <div class="w-3 h-3 bg-green-500 rounded-full mr-2 animate-pulse"></div>
            Estado del Sistema
          </h3>
          <div class="space-y-3">
            <div class="flex justify-between items-center">
              <span class="text-marbel-gray text-sm">Base de datos</span>
              <span class="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs">Conectado</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-marbel-gray text-sm">Última sincronización</span>
              <span class="text-marbel-gray text-xs">Hace 2 minutos</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-marbel-gray text-sm">Versión del sistema</span>
              <span class="bg-marbel-aqua/20 text-marbel-aqua px-2 py-1 rounded-full text-xs">v3.1</span>
            </div>
          </div>
        </div>

        <!-- Información de contacto -->
        <div class="bg-white rounded-xl shadow-lg p-6">
          <h3 class="text-lg font-bold text-marbel-gray mb-4">Contacto MARBEL</h3>
          <div class="space-y-3">
            <div class="flex items-center space-x-3">
              <div class="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                <svg class="w-4 h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
                </svg>
              </div>
              <div>
                <p class="text-sm font-medium text-marbel-gray">WhatsApp</p>
                <p class="text-xs text-marbel-gray/70">8182594565</p>
              </div>
            </div>
            <div class="flex items-center space-x-3">
              <div class="w-8 h-8 bg-marbel-aqua/20 rounded-full flex items-center justify-center">
                <svg class="w-4 h-4 text-marbel-aqua" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"/>
                </svg>
              </div>
              <div>
                <p class="text-sm font-medium text-marbel-gray">Ubicación</p>
                <p class="text-xs text-marbel-gray/70">Monterrey, Nuevo León</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer personalizado MARBEL -->
    <MarbelFooter />
  </div>
</template>

    
<script>
import MarbelFooter from '@/components/MarbelFooter.vue'


import {
    reactive,
    ref
} from "vue";
import userService from "@/Services/user";

import {
    emitter
} from "@/mitt.js";
import {
    useUserStore
} from '@/stores/user'
import {
    useConfigStore
} from '@/stores/config'
import {
    useRouter,
    useRoute
} from 'vue-router'
export default {
    name: "Home",
    components: {
        MarbelFooter
    },
    props: {
        title: {
            type: Number,
            default: 0
        },

    },
    setup(props) {
        const router = useRouter()
        const route = useRoute()
        const user = useUserStore()
        const config = useConfigStore()
        const step = ref(1)
        const tipoperfil = ref(1)
        // expose to template and other options API hooks
        return {
            user: user.getAll(),
            config,
            router,
            route,
            step,
            tipoperfil

        }

    },
    data() {
        return {
            email: '',
            username: '',
            genero: 'Hombre',
            year_u: 0,
            idioma_u: 'es',
            pais: 'Mexico',
            instagram: '',
            facebook: '',
            tiktok: '',
            twiter: '',
            msg: [],
            paises: new Array("Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antarctica", "Antigua and Barbuda",
                "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados",
                "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana",
                "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burma", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde",
                "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo, Democratic Republic",
                "Congo, Republic of the", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark",
                "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea",
                "Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana",
                "Greece", "Greenland", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong",
                "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan",
                "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kuwait", "Kyrgyzstan", "Laos", "Latvia",
                "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macedonia", "Madagascar",
                "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia",
                "Moldova", "Mongolia", "Morocco", "Monaco", "Mozambique", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand",
                "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Panama", "Papua New Guinea", "Paraguay", "Peru",
                "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Samoa", "San Marino", " Sao Tome",
                "Saudi Arabia", "Senegal", "Serbia and Montenegro", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia",
                "Solomon Islands", "Somalia", "South Africa", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden",
                "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad and Tobago",
                "Tunisia", "Turkey", "Turkmenistan", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States",
                "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"),

            idiomas: [{
                    id: 'es',
                    nombre: 'Espanol'
                },
                {
                    id: 'en',
                    nombre: 'Ingles'
                },
                {
                    id: 'fr',
                    nombre: 'Frences'
                },
                {
                    id: 'italiano',
                    nombre: 'Italiano'
                },

            ]
        }
    },
    watch: {
        email(value) {
            // binding this to the data value in the email input
            this.email = value;
            this.validateEmail(value);
        },
        edad(value) {
            // binding this to the data value in the email input
            this.edad = value;
            //this.validateEdad(value);
        }
    },
    mounted() {
        this.verificarPerfil()
    },
    methods: {
         showMenu1 (flag)  {
             let menu1 = document.getElementById("menu1");

    if (flag) {
        icon1.classList.toggle("rotate-180");
        menu1.classList.toggle("hidden");
    }
},

 showMenu2  (flag)  {
     let menu2 = document.getElementById("menu2");

    if (flag) {
        icon2.classList.toggle("rotate-180");
        menu2.classList.toggle("hidden");
    }
},


 showMenu3 (flag)  {
     let menu3 = document.getElementById("menu3");
    if (flag) {
        icon3.classList.toggle("rotate-180");
        menu3.classList.toggle("hidden");
    }
},
        years() {
            const year = new Date().getFullYear()
            return Array.from({
                length: year - 1900
            }, (value, index) => 1901 + index)
        },
        validateEmail(value) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
                this.msg['email'] = '';
            } else {
                this.msg['email'] = 'Invalid Email Address';
            }
        },
        async verificarPerfil() {

            if (this.user.primer_acceso) {
                switch (this.user.role) {
                    case 'general':
                        router.push('/app/stream');
                        break;
                    case 'creator':
                        router.push('/app/creator');
                        break;

                    default:
                        break;
                }
            }

        }
    }
};
</script>

<style scoped>

</style>
